import { render } from "./App.vue?vue&type=template&id=2bfb4e0c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2bfb4e0c&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__